<template>
  <div class="myCenter modelPage formStyle">
    <div class="myCenterMain">
      <van-nav-bar>
        <template #left>
          <img style="width: 60%;" @click="$router.push({ path: `/` })" src="@/assets/img/logo_yoko.svg" alt="" />
        </template>
        <template #right>
          <div class="iconBox" @click="$router.push({ path: `/notify` })">
            <img class="notice" src="../../assets/img/icon/icon_notice.png" />
            <div class="tips" v-if="form.hasUnread"></div>
          </div>
        </template>
      </van-nav-bar>
      <div class="isContent">
        <div class="loginForm">
          <div class="avatarBox">
            <img v-if="form.avatar" class="avatar" :src="form.avatar" />
            <img v-else class="avatar" src="../../assets/img/avatar.png" />
            <!-- <img
            @click="showActionSheet = true"
            class="icon_camera"
            src="../../assets/img/icon/icon_camera.png"
          /> -->
            <img
              @click="showActionSheet = true"
              class="icon_camera"
              src="../../assets/img/icon/icon_camera.png"
            />
            <input type="file" @change="uploadFile" />
          </div>
          <van-form class="loginFormBox">
            <div>ユーザー名</div>
            <div class="userInfoItems">
              <van-field class="fontStyle" v-model="form.nickname" readonly />
              <div
                class="edit"
                @click="goeditUserInfo('name', 'ユーザー名変更')"
              >
                <img class="icon" src="../../assets/img/icon/icon_edit.png" />
              </div>
            </div>
            <div style="margin-top: 6px;">User ID</div>
            <van-field class="fontStyle" v-model="form.id" readonly />
            <div>メールアドレス</div>
            <div class="userInfoItems">
              <van-field
                class="fontStyle"
                v-model="form.mailbox"
                placeholder="メールアドレスを入力してください"
                readonly
              />
              <div
                class="edit"
                @click="goeditUserInfo('email', 'メールアドレス変更')"
              >
                <img class="icon" src="../../assets/img/icon/icon_edit.png" />
              </div>
            </div>
            <div>パスワード</div>
            <div class="userInfoItems">
              <van-field v-model="pwd" type="password" readonly />
              <div class="edit" @click="$router.push({ path: `/password` })">
                <img class="icon" src="../../assets/img/icon/icon_edit.png" />
              </div>
            </div>
            <div>会社名</div>
            <div class="userInfoItems">
              <van-field
                class="fontStyle"
                v-model="form.companyName"
                readonly
              />
              <div
                class="edit"
                @click="goeditUserInfo('company', '会社名変更')"
              >
                <img class="icon" src="../../assets/img/icon/icon_edit.png" />
              </div>
            </div>
          </van-form>
        </div>

        <div class="loginForm cellListStyle mtop16">
          <van-cell
            title="サポート"
            is-link
            @click="$router.push({ path: `/set` })"
          />
          <van-cell
            title="ベーシックプラン"
            is-link
            @click="$router.push({ path: `/unlockPackage` })"
          />
        </div>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="buttonBlue"
          @click="logOut()"
          >ログアウト</van-button
        >
      </div>
    </div>
    <van-action-sheet
      class="avatarActionSheet"
      v-model="showActionSheet"
      title="プロフィール画像を修正します"
    >
      <div class="contentItem">
        <div class="items">
          アルバムです
          <input type="file" @change="uploadFile" accept="image/*;" />
        </div>
        <div class="items" v-if="isApp">
          ビデオ撮影です
          <input
            type="file"
            @change="uploadFile"
            accept="image/*"
            capture="camera"
          />
        </div>
      </div>
    </van-action-sheet>
    <van-overlay :show="loadingShow" z-index="9990">
      <div class="wrapper">
        <van-loading type="spinner" color="#fff" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { ActionSheet } from "vant";
import { Toast } from "vant";
import { Overlay } from "vant";

Vue.use(Overlay);
Vue.use(ActionSheet);
Vue.use(Toast);
import { userInfo, authLogOut, updateAvatar } from "@/http/user";
import axios from "axios";
export default {
  data() {
    return {
      pwd: "12345678",
      form: {
        nickname: "",
        id: "",
        mailbox: "",
        companyName: "",
        hasUnread: false
      },
      loadingShow: false,
      showActionSheet: false,
      isApp: false
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isApp = true;
    }
    this.getUserInfo();
  },
  methods: {
    // 判断是否是手机端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getUserInfo() {
      userInfo().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.form = data;
        }
      });
    },
    goeditUserInfo(type, title) {
      this.$router.push({ path: `/user`, query: { type: type, title: title } });
    },
    logOut() {
      // authLogOut().then(res => {
      //   let { data, code } = res.data;
      //   if (code == 200) {
      localStorage.removeItem("token");
      this.$router.push({ path: `/login` });
      //   }
      // });
    },
    uploadFile(e) {
      this.showActionSheet = false;
      this.loadingShow = true;
      let _this = this;
      var files = e.target.files[0];
      let form = new FormData();
      form.append("file", files);
      let USER_TOKEN = localStorage.getItem("token")
        ? localStorage.getItem("token")
        : "";
      const instance = axios.create({
        withCredentials: true
      });
      instance({
        method: "post",
        url: "https://apibk.smartsketcher-ai.com/app-api/system/s3/upload",
        data: form,
        headers: {
          Authorization: "Bearer " + USER_TOKEN,
          "tenant-Id": "1",
          "Content-Type": "multipart/form-data"
        }
      })
        .then(res => {
          let { data, code } = res.data;
          if (code == 200) {
            updateAvatar({ avatarFile: data }).then(res => {
              this.loadingShow = false;
              let { data, code } = res.data;
              if (code == 200) {
                Toast({
                  type: "success",
                  message: "変更しました"
                });
                this.getUserInfo();
              } else {
                Toast({
                  type: "fail",
                  icon: "cross",
                  message: res.data.msg
                });
              }
            });
          } else {
            Toast({
              type: "fail",
              icon: "cross",
              message: res.data.msg
            });
          }
        })
        .catch(err => {
          this.loadingShow = false;
          localStorage.removeItem("token");
          router.push({ path: `/login` });
        });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style src="@/assets/css/form.css" scoped></style>
<style>
.myCenter {
  position: relative;
}
.myCenter .myCenterMain {
  width: 100%;
  height: 100%;
  padding-bottom: 105px;
  /* height: calc(100% - 105px); */
  /* margin-bottom: 100px; */
  box-sizing: border-box;
}
.myCenter .isContent {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.myCenter .iconBox {
  position: relative;
}
.myCenter .iconBox .tips {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 3;
  border-radius: 50%;
  background: #ff2f6a;
}
.myCenter .iconBox .notice {
  width: 18px;
  height: 22px;
}
.myCenter .avatarBox {
  width: 96px;
  height: 96px;
  margin: -72px auto 0 auto;
  border-radius: 50%;
  position: relative;
}
.myCenter .avatarBox .logo {
  width: 100%;
}
.myCenter .avatarBox .avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.myCenter .avatarBox .icon_camera {
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.aiCenter .avatarBox input {
  position: absolute;
  font-size: 100px;
  right: 3px;
  bottom: 3px;
  opacity: 0;
  width: 20px;
  height: 20px;
}
.myCenter .myCenterMain .buttonBlue {
  width: 87%;
  margin: 54px auto 0 auto;
}
.fontStyle input {
  font-size: 14px;
  font-family: RegularFont;
}
.myCenter .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.aiCenter .van-popup.avatarActionSheet {
  width: 100%;
  background: #fff;
  padding-top: 0;
  border-radius: 16px 16px 0 0;
  /* min-height: 100px */
  padding-bottom: 20px;
}
.aiCenter .van-popup.avatarActionSheet .van-action-sheet__header {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
}
.aiCenter .van-popup.avatarActionSheet .van-action-sheet__close {
  color: rgb(0, 0, 0, 0.5);
}
.aiCenter .van-popup.avatarActionSheet .contentItem .items:first-child {
  border: none;
}
.aiCenter .van-popup.avatarActionSheet .contentItem .items {
  border-top: 1px solid #f2f2f2;
  font-size: 16px;
  padding: 10px 0;
  cursor: pointer;
  text-align: center;
  font-family: RegularFont;
  color: rgba(0, 0, 0, 0.9);
  position: relative;
  display: inline-block;
  text-decoration: none;
  text-indent: 0;
  overflow: hidden;
  width: 100%;
}
.aiCenter .van-popup.avatarActionSheet .contentItem .items input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 40px;
}
.aiCenter .van-popup.avatarActionSheet .contentItem .items i:hover {
  background: #fff;
  color: rgba(0, 0, 0, 0.9);
  text-decoration: none;
}
@media screen and (min-width: 1439px) {
  .myCenter .myCenterMain {
    padding-bottom: 15px; /* no*/
    /* height: calc(100% - 105px); */
     /* no*/
    /* margin-bottom: 100px; */
     /* no*/
  }
  .myCenter .iconBox .tips {
    width: 10px; /* no*/
    height: 10px; /* no*/
    top: 2px; /* no*/
    right: 2px; /* no*/
  }
  .myCenter .iconBox .notice {
    width: 18px; /* no*/
    height: 22px; /* no*/
  }
  .myCenter .avatarBox {
    width: 96px; /* no*/
    height: 96px; /* no*/
    margin: -66px auto 0 auto; /* no*/
  }
  .myCenter .avatarBox .icon_camera {
    right: 3px; /* no*/
    bottom: 3px; /* no*/
    width: 20px; /* no*/
    height: 20px; /* no*/
  }
  .aiCenter .van-popup.avatarActionSheet {
    border-radius: 16px 16px 0 0; /* no*/
    padding-bottom: 20px; /* no*/
  }
  .aiCenter .van-popup.avatarActionSheet .van-action-sheet__header {
    font-size: 14px;
  }
  .aiCenter .van-popup.avatarActionSheet .contentItem .items {
    border-top: 1px solid #f2f2f2; /* no*/
    font-size: 16px; /* no*/
    padding: 10px 0; /* no*/
  }
  .aiCenter .van-popup.avatarActionSheet .contentItem .items input {
    font-size: 100px; /* no*/
    height: 40px; /* no*/
  }
  .myCenter .myCenterMain .buttonBlue {
    margin: 54px auto 0 auto; /* no*/
  }
  .fontStyle input {
    font-size: 14px; /* no*/
  }
  .fontStyle input::input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-webkit-input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-ms-input-placeholder {
    font-size: 14px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myCenter/index.vue